import logoForDarkSurface from '@/assets/brand/logo-horizontal-dark.svg'
import logoForLightSurface from '@/assets/brand/logo-horizontal-light.svg'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'
import { useTheme } from '@/design-system/theme/useTheme'

export interface BrandLogoProps {
  className?: string
  alt?: string
}

export function BrandLogo({ className, alt = 'Groupe RECA' }: BrandLogoProps) {
  const { resolvedTheme } = useTheme()

  return (
    <span className={mergeClassNames('brand-logo', className)}>
      <img src={resolvedTheme === 'dark' ? logoForDarkSurface : logoForLightSurface} alt={alt} />
    </span>
  )
}
